//Generating a random hex color (For charts)
export default function generateColor() {
  return '#' + Math.floor(Math.random() * 16777215).toString(16);
}
